// Подписи для людей: даты по-русски, деньги, склонения.
import { pad2 } from './dates.ts';

export const RU_DAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'] as const;
export const RU_DAYS_FULL = ['понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота', 'воскресенье'] as const;
export const RU_MONTHS_GEN = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября',
  'октября', 'ноября', 'декабря'] as const;
export const RU_MONTHS = ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь',
  'ноябрь', 'декабрь'] as const;
export const RU_MON_SHORT = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'] as const;

function nums(s: string): number[] {
  return s.split('-').map(Number);
}

// «24 сентября», «24 сентября 2026»
export function ruDate(s: string, withYear = false): string {
  const [y = 0, m = 1, d = 1] = nums(s);
  return d + ' ' + RU_MONTHS_GEN[m - 1] + (withYear ? ' ' + y : '');
}

// «24.09.2026»
export function ruDateShort(s: string): string {
  const [y = 0, m = 1, d = 1] = nums(s);
  return pad2(d) + '.' + pad2(m) + '.' + y;
}

// «сентябрь 2026»
export function ruMonth(ym: string): string {
  const [y = 0, m = 1] = nums(ym);
  return RU_MONTHS[m - 1] + ' ' + y;
}

export function plural(n: number, one: string, few: string, many: string): string {
  const n100 = Math.abs(n) % 100, n10 = n100 % 10;
  if (n100 > 10 && n100 < 20) return many;
  if (n10 > 1 && n10 < 5) return few;
  if (n10 === 1) return one;
  return many;
}

// Валюты с копейками; остальные (драмы, рубли) — целыми.
export const CENTS: Readonly<Record<string, boolean>> = { EUR: true, USD: true, GEL: true, GBP: true };
const SIGN: Readonly<Record<string, string>> = { EUR: '€', USD: '$', RUB: '₽', GEL: '₾', GBP: '£' };

// «15 000 ₽», «12,50 €», «−3 000 AMD» (между тысячами — тонкий пробел)
export function money(n: number | null | undefined, cur?: string | null): string {
  if (n === null || n === undefined || Number.isNaN(n)) return '';
  const c = cur ?? '', cents = CENTS[c] === true;
  let v = cents ? Math.round(n * 100) / 100 : Math.round(n);
  const neg = v < 0;
  v = Math.abs(v);
  const s = (cents && v % 1 ? v.toFixed(2).replace('.', ',') : String(Math.round(v)))
    .replace(/\B(?=(\d{3})+(?!\d))/g, '\u2009');       // тонкий пробел между тысячами, как в первой версии
  const sign = SIGN[c];
  return (neg ? '−' : '') + s + (sign ? ' ' + sign : c ? ' ' + c : '');
}

// Правило оплаты отмены словами: «без оплаты», «полная цена», «50% цены», «2 000 ₽».
export function ruleLabel(rule: string | null | undefined, cur?: string | null): string {
  const s = String(rule ?? '').trim();
  if (!s || s === '0' || s === '0%') return 'без оплаты';
  if (/%$/.test(s)) return s === '100%' ? 'полная цена' : s + ' цены';
  return money(parseFloat(s.replace(',', '.')), cur);
}

export function balanceLabel(balance: number, cur?: string | null): string {
  if (!balance) return '0';
  return balance < 0 ? 'долг ' + money(-balance, cur) : 'аванс ' + money(balance, cur);
}
